import React from "react";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {getImageUrl} from "../helpers/getImageUrl";

const Lesson = ({ lesson }) => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{ borderRadius: "15px", cursor: "pointer" }}
      onClick={() => navigate(`/academy/lesson/${lesson.id}`)}
    >
      <CardMedia
        component="img"
        height="200"
        image={lesson.previewKey ? getImageUrl(lesson.previewKey) : "/images/lesson.png"}
        alt={lesson.name}
      />
      <CardContent>
        <Typography variant="h6" component="h2">
          {lesson.name}
        </Typography>
        <Typography color="textSecondary" sx={{ fontSize: "12px" }}>
          Урок обновлен:{" "}
          {new Date(lesson.updatedAt).toLocaleDateString("ru-RU")}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default Lesson;
